
function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

export function generateChartColor(colors) {
    let no = getRandomInt(4);
    let colorName = Object.keys(colors)[no];
    let color = colors[colorName];
    return color;

}

export function fold(s, n, useSpaces, a) {
    a = a || [];
    if (s.length <= n) {
        a.push(s);
        return a;
    }
    var line = s.substring(0, n);
    if (! useSpaces) { // insert newlines anywhere
        a.push(line);
        return fold(s.substring(n), n, useSpaces, a);
    }
    else { // attempt to insert newlines after whitespace
        var lastSpaceRgx = /\s(?!.*\s)/;
        var idx = line.search(lastSpaceRgx);
        var nextIdx = n;
        if (idx > 0) {
            line = line.substring(0, idx);
            nextIdx = idx;
        }
        a.push(line);
        return fold(s.substring(nextIdx), n, useSpaces, a);
    }
}

// Regex version of fold function.

function foldRgx(s, n) {
    var rgx = new RegExp('.{0,' + n + '}', 'g');
    return s.match(rgx);
}